import React from 'react'
import { Table, Menu, ActionIcon, NumberFormatter } from '@mantine/core'
import { IconDotsVertical, IconPencil, IconTrash } from '@tabler/icons-react'
import dayjs from 'dayjs'

const ActionMenu = ({ handleAction }) => {
  return (
    <Menu width={200} position="bottom-end" withArrow arrowPosition="center">
      <Menu.Target>
        <ActionIcon ml={8} pt={6} variant='transparent' size='xs'>
          <IconDotsVertical stroke={1.5} />
        </ActionIcon>
      </Menu.Target>
      <Menu.Dropdown>
        <Menu.Item
          leftSection={<IconPencil stroke={1.5} size={14} />}
          onClick={() => handleAction('edit')}
          fw='600'
          fz={11}
        >
          Edit
        </Menu.Item>
        <Menu.Item
          color='red'
          leftSection={<IconTrash stroke={1.5} size={14} />}
          onClick={() => handleAction('delete')}
          fw='600'
          fz={11}
        >
          Delete
        </Menu.Item>
      </Menu.Dropdown>
    </Menu>
  )
}

const TableUserCommision = ({ label, data, actionMethod }) => {
   const mappingTableHead = (data) => data.map((val, index) => {
    return (<Table.Th key={index} width={val.width !== 'auto' ? val.width : ''}>{val.label}</Table.Th>)
  })

  const mappingDataTable = (data) => data.map((val, index) => {
    return (
      <Table.Tr key={index}>
        <Table.Td>{index + 1}</Table.Td>
        <Table.Td>{dayjs(val.updated_at).format('DD MMMM YYYY')}</Table.Td>
        <Table.Td>{val.label || '-'}</Table.Td>
        <Table.Td>{val.supplier_name || '-'}</Table.Td>
        <Table.Td>{val.order_ref || '-'}</Table.Td>
        <Table.Td c={val.commission_typename === 'income' ? 'green' : 'red'}>
          {val.commission_typename === 'income' ? '+ ' : '- '}
          <NumberFormatter  prefix={`${val.currency} `} thousandSeparator="," decimalSeparator="." decimalScale={2} fixedDecimalScale={true} value={val.amount || 0} />
        </Table.Td>
        <Table.Td c='green'>
          <NumberFormatter prefix={`${val.currency} `} thousandSeparator="," decimalSeparator="." decimalScale={2} fixedDecimalScale={true} value={val.last_balance || 0} />
        </Table.Td>
        <Table.Td><ActionMenu handleAction={(type) => actionMethod(val, type)} /></Table.Td>
      </Table.Tr>
    )
  })
  return (
    <Table.ScrollContainer minWidth={1366} type='native'>
      <Table highlightOnHover withTableBorder style={{ fontSize: '13px' }}>
        <Table.Thead style={{ backgroundColor: '#eeefef' }}>
          <Table.Tr>
            {mappingTableHead(label)}
          </Table.Tr>
        </Table.Thead>
        <Table.Tbody style={{ verticalAlign: 'top' }}>
          {mappingDataTable(data)}
        </Table.Tbody>
      </Table>
    </Table.ScrollContainer>
  )
}

export default TableUserCommision